import { queryClient } from "../common/query";

// eslint-disable-next-line no-unused-vars
const writeToStorage = async (queryKey, data) => {
    localStorage.setItem(queryKey, JSON.stringify(data));
};

const readFromStorage = (queryKey) => {
    const storageData = localStorage.getItem(queryKey);
    if (storageData) {
        const parsedData = JSON.parse(storageData);
        if (parsedData) {
            return parsedData;
        }
    }
};

const clearStorage = async () => {
    await localStorage.clear();
    queryClient.invalidateQueries();
    queryClient.cancelQueries();
    queryClient.resetQueries();
};

export { readFromStorage, writeToStorage, clearStorage };
